import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/admin" element={<AdminLoginPage data-id="element-5" />} data-id="element-4" />
        <Route path="/admin/dashboard" element={<AdminDashboardPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </Router>;
}